<template>
  <v-data-table
    :headers="cp_headers"
    :items="cp_items"
    class="elevation-1"
    :loading="propsLoading"
    loading-text="Загружаю данные"
    item-key="CELL_ID"
    :items-per-page="-1"
    :hide-default-footer="true"
    locale="ru-RU"
    dense
  >
    <template v-slot:top>
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Сводная таблица</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:item="{ item, headers }">
      <tr>
        <td v-for="header in headers" :key="item.ROW_NUM + header.value" :class="header.cellClass">
          <v-btn icon x-small class="red darken-4" v-if="!item[header.value]">
            <v-icon class="white--text">mdi-exclamation-thick</v-icon>
          </v-btn>
          <div v-else>{{ item[header.value] }}</div>
        </td>
      </tr>
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
  </v-data-table>
</template>

<script>
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'
import { RCPT_GET_COMPONENTS, RCPT_GET_COMP_PROPERTIES } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'

export default {
  name: 'tblPropCompCombined',
  props: ['project'],
  mixins: [numDecorator],
  components: {
  },
  data () {
    return {
      propsLoading: false,
      propSearch: '',
      selectedProp: [],
      prop_items: [],
      comp_items: []
    }
  },
  watch: {
    project (val) {
      console.log('tblPropCompCombined component watcher detected project change to ', val)
      if (val && val.ULF_ID) {
        this.getCmpList()
      }
    },
    comp_items (val) {
      val.forEach(item => {
        this.getPropList(item)
      }, this)
    }
  },
  computed: {
    cp_headers: {
      get: function () {
        const ret = [
          { text: '#', align: 'start', width: '5%', divider: true, class: 'blue-grey spcell-grey lighten-4 black--text font-weight-black', cellClass: 'spcell-grey black--text font-weight-black', value: 'ROW_NUM' },
          { text: this.project.ULF_NAME, divider: true, class: 'blue-grey lighten-4 black--text font-weight-black', align: 'center', cellClass: 'spcell-grey text-start black--text font-weight-black', value: 'PROP_NAME' }
        ]
        const cols = this.comp_items.map(function (item) {
          const itm = {
            text: item.COMP_NAME,
            align: 'center',
            class: 'black--text font-weight-black blue-grey lighten-4',
            cellClass: 'text-center spcell-white',
            value: 'PROP_VALUE_' + item.COMP_ID
          }
          return itm
        })
        ret.push(...cols)
        console.log('Returning cols ', ret)
        return ret
      }
    },
    cp_items: {
      get: function () {
        let i = 0
        const comps = this.comp_items
        const props = this.prop_items
        const self = this
        const result = props.reduce(function (acc, prop) {
          if (acc.find(r => r.PROP_NAME === prop.PROP_NAME)) return acc
          const row = {
            ROW_NUM: i + 1,
            PROP_NAME: prop.PROP_NAME
          }
          comps.map(function (comp) {
            const p = props.find(p => p.PROP_NAME === prop.PROP_NAME && p.COMP_ID === comp.COMP_ID)
            if (p) {
              row['PROP_VALUE_' + comp.COMP_ID] = self.numLocaleDecorator(p.CURR_PROP_VALUE)
            }
          })
          acc.push(row)
          i++
          return acc
        }, [])
        return result
      }
    }
  },
  mounted: function () {
    if (this.comp_items.length === 0 && this.project) {
      this.getCmpList()
    }
  },
  methods: {
    getPropList (comp) {
      this.propsLoading = true
      this.$store.dispatch(RCPT_GET_COMP_PROPERTIES, { COMP_ID: comp.COMP_ID, ULF_ID: this.project.ULF_ID })
        .then((res) => {
          this.prop_items.push(...res)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
        })
        .finally(() => {
          this.propsLoading = false
        })
    },
    getCmpList () {
      this.prop_items.splice(0, this.prop_items.length)
      this.$store.dispatch(RCPT_GET_COMPONENTS, { ULF_ID: this.project.ULF_ID || null })
        .then((res) => {
          this.comp_items.splice(0, this.comp_items.length, ...res)
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${err}` })
        })
        .finally(() => {
          this.propsLoading = false
        })
    }
  }
}
</script>

<style scoped>
 .spcell-white {
   border-bottom: 1px solid #CFD8DC;
   background-color: #FFFFFF;
 }
 .spcell-grey{
   border-bottom: 1px solid #CFD8DC;
   background-color: #CFD8DC!important;
 }
</style>
